import { ODSSwitch } from '@telekom-ods/react-ui-kit';
import PropTypes from 'prop-types';

export const Switch = ({
  id = '',
  name,
  label,
  checked = false,
  disabled = false,
  onChange,
  onBlur = () => {},
  size = 'small',
}) => {
  let displayedLabel = label;
  if (typeof label === 'object') {
    displayedLabel = checked ? label.on : label.off;
  }

  return (
    <ODSSwitch
      id={id || name}
      name={name}
      disabled={disabled}
      size={size}
      selected={checked}
      onSelectedChange={onChange}
      onBlur={onBlur}
      label={displayedLabel}
    />
  );
};

Switch.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.shape({
      on: PropTypes.string.isRequired,
      off: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  size: PropTypes.oneOf(['small', 'large']),
};
